module.exports = function() {
  return new Worker(__webpack_public_path__ + "b14d5d225ab5db71347d.worker.js");
};